export const stepOneData = [
  {
    heading: "Why Use ICICI Bank Home Loan EMI Calculator?",
    // paras before heading

    infoList: [
      {
        heading: "Instant Results: ",
        description:
          "Get your EMI calculated in seconds with the provided information.",
      },
      {
        heading: "Clear Insights:: ",
        description:
          "Understand how loan amount, tenure, and interest rates affect your monthly payments.",
      },
      {
        heading: "Free and Easy: ",
        description:
          "The calculator is available for free and is simple to use, allowing you to plan your finances better.",
      },
      {
        heading: "Loan Comparison: ",
        description:
          "Compare multiple loan scenarios by adjusting the parameters and make the most suitable choice.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    heading: "Key Features of ICICI Bank Home Loan EMI Calculator",

    tableContent: {
      heading: [
        {
          head: "Loan Type",
        },
        {
          head: "Interest Rate (Starting)",
        },
        {
          head: "Loan Tenure",
        },
        {
          head: "Processing Fees",
        },
      ],
      row: [
        {
          type: "Home Loan",
          interest: "8.50% p.a.",
          tenure: "Up to 30 years",
          fee: "₹3,000 - ₹25,000",
        },
      ],
    },
  },
];

export const stepThreeData = [
  {
    heading: "Factors Influencing Your EMI and Total Repayment",

    factorsList: [
      {
        heading: "Loan Amount: ",
        info: "The more you borrow, the higher your EMI. It’s important to balance your loan amount with your income and repayment capacity.",
      },
      {
        heading: "Interest Rate: ",
        info: "The higher the rate, the higher the EMI and total repayment. Always compare offers before choosing a loan.",
      },
      {
        heading: "Loan Tenure: ",
        info: "While longer tenures result in lower EMIs, they lead to higher total repayment due to accumulated interest. Shorter tenures reduce your overall repayment but increase your EMI.",
      },
      {
        heading: "Processing Fees: ",
        info: "ICICI charges processing fees that can vary based on the loan amount and type of loan. Ensure you factor in these costs when calculating your total borrowing expenses.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "Impact of Loan Tenure on EMI and Total Repayment",
    paraOne:
      "Loan tenure directly affects both your EMI amount and the total repayment amount. Here’s how:",
    tableContent: {
      heading: [
        {
          head: "Loan Tenure",
        },
        {
          head: "Monthly EMI",
        },
        {
          head: "Interest Paid",
        },
        {
          head: "Total Repayment",
        },
      ],
      row: [
        {
          tenure: "5 years",
          emi: "Higher EMI	",
          interest: "Lower Interest",
          repayment: "Lower Total",
        },
        {
          tenure: "10 years	",
          emi: "Moderate EMI",
          interest: "Moderate Interest",
          repayment: "Moderate Total",
        },
        {
          tenure: "15 years",
          emi: "Lower EMI	",
          interest: "Higher Interest",
          repayment: "Higher Total",
        },
        {
          tenure: "20 years",
          emi: "Very Low EMI	",
          interest: "Much Higher Interest	",
          repayment: "Much Higher Total",
        },
      ],
    },
  },
];

export const stepFiveData = [
  {
    heading: "Why Consider APR Over Just Interest Rates?",
    tip: "Compare loans based on APR, as it helps you assess the total cost of your loan more accurately than interest rates alone.",
  },
];

export const stepSixData = [
  {
    heading: "ICICI Bank Home Loan EMI Breakdown",
    paraOne: "Your monthly EMI consists of two parts:",
    infoList: [
      {
        head: "Principal: ",
        info: "The amount you borrow, which is paid back over time.",
      },
      {
        head: "Interest: ",
        info: "The cost of borrowing the money, calculated as a percentage of the principal.",
      },
    ],
    paraTwo:
      "During the initial years of your home loan, a larger portion of your EMI goes toward paying the interest, while later years see a higher percentage going toward the principal. This structure is known as the amortization process.",
  },
];

export const stepSevenData = [
  {
    heading: "MinEmi Tips for Borrowing from ICICI Bank",
    infoList: [
      {
        head: "Choose the Right Loan Amount: ",
        info: "Assess your financial capacity before deciding on the loan amount. Borrowing too much may strain your finances, while borrowing too little may not cover your needs.",
      },
      {
        head: "Opt for a Loan Tenure That Fits Your Budget: ",
        info: "A shorter tenure means higher EMIs but less interest paid over the term, while a longer tenure offers smaller EMIs but higher total repayment.",
      },
      {
        head: "Prepayment Facility: ",
        info: "ICICI offers part-prepayment options without additional charges (subject to terms). Make use of this feature to reduce your principal and save on interest costs.",
      },
      {
        head: "Check Processing Fees: ",
        info: "Ensure you understand the processing fees before finalizing your loan. These can be a significant addition to your loan amount.",
      },
    ],
  },
];
